// Brand constants for Social IQ (powered by InnovAItion)
import logoSrc from "@/assets/innovaition-logo.jpg";

export const BRAND = {
  name: "Social IQ",
  tagline: "powered by InnovAItion",
  logo: logoSrc,
  colors: {
    cyan: "#00D4FF",
    lime: "#C8FF4D",
    bg: "#0a0a0f",
  },
  ablefy: {
    // Einmalkauf 97 € — Justine legt das Produkt in Ablefy an und ersetzt diesen Link.
    lifetime: "https://myablefy.com/s/erfolgbeginntindir/socialiq/payment",
  },
  pricing: {
    lifetime_eur: 97,
    affiliate_percent: 45,
  },
  contact: "info@viral-cut-ai.de",
};
